import BlobIcon, { BlobIconTypes } from '@totallymoney/ui/components/BlobIcon'
import Box from '@totallymoney/ui/components/Box'
import Heading from '@totallymoney/ui/components/Heading'
import Row from '@totallymoney/ui/components/Row'
import Stack from '@totallymoney/ui/components/Stack'
import theme from '@totallymoney/ui/theme'

import { CreditCardProductCategory } from '@appTypes/EligibilityApi.interface'

import { creditCardBenefits } from './lib/creditCardBenefits'
import { creditCardInformation } from './lib/creditCardInformation'

const createBenefitsList: Record<number, BlobIconTypes> = {
    0: 'money',
    1: 'thumbsUp',
    2: 'celebrate',
    3: 'otherAccounts',
}

const UnscoredCategoryPageAboutSection = ({
    page,
}: {
    page: CreditCardProductCategory
}) => {
    const information = creditCardInformation[page]
    const benefits = creditCardBenefits[page]

    return (
        <Box gridColumn="1/13">
            <Box
                display="grid"
                gridTemplateColumns={['1fr', 'repeat(2, 1fr)']}
                gridGap={['space30', 'space30', 'space50']}
            >
                <Stack space="space15">
                    {benefits?.map((benefit, i) => (
                        <Row
                            key={`${benefit}-${i}`}
                            space="space20"
                            p="space15"
                            backgroundColor={theme.indigo10}
                            borderRadius="borderRadius20"
                            alignItems="center"
                            width="100%"
                        >
                            <Box aria-hidden>
                                <BlobIcon
                                    blobName={createBenefitsList[i]}
                                    size={40}
                                />
                            </Box>

                            <Box>
                                <Heading variant="20">{benefit}</Heading>
                            </Box>
                        </Row>
                    ))}
                </Stack>

                {information}
            </Box>
        </Box>
    )
}

export default UnscoredCategoryPageAboutSection
